import React, { useEffect, useState, useRef } from "react";
import Header from "../../../Componets/Header";
import { useLocation } from "react-router-dom";
import purcases from "../../../Data/purchases.json";
import suppliers from "../../../Data/suppliers.json";
import toast from "react-hot-toast";
import { get_all_purchases } from "../../../Controllers/Purchases/Orders";
import moment from "moment";
import Loadercomponent from "../../../Componets/Loader";
import { get_purchase_tax_reports } from "../../../Controllers/Dashboard/Dashboard";
import ReactToPrint from "react-to-print";
import { Button } from "antd";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { registerCairoFont } from "../cairo-font";
import ScrollWrapper from "../../../Componets/ScrollWrapper";


const PurchasesVatReport = () => {
  let location = useLocation();
  let componentRef = useRef();

  const [loader, setLoader] = useState(false);
  const [body, setBody] = useState();
  const [role, setRole] = useState();

  const headers = {
    name: "Purchases",
    components: [
      {
        type: "search",
        name: "search",
        placeholder: "Search",
        value: "",
      },
      {
        type: "select",
        name: "sort",
        placeholder: "Sort",
        allowClear: true,
        showSearch: false,
        filterOption: true,
        value: null,
        options: [
          { value: 0, label: "Price (Low-High)" },
          { value: 1, label: "Price (High-Low)" },
        ],
      },
      {
        type: "filter",
        name: "supplier",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        placeholder: "Supplier",
        api: "get-all-suppliers",
        value: null,
        options: null,
      },
      {
        type: "filter",
        name: "branch",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        placeholder: "Branch",
        api: "get-all-branches",
        value: null,
        options: null,
      },
      {
        type: "filter",
        name: "status",
        placeholder: "Status",
        value: null,
        allowClear: true,
        showSearch: false,
        filterOption: true,
        options: [
          { value: 0, label: "Inactive" },
          { value: 1, label: "Active" },
        ],
      },
      {
        type: "range",
        name: "date",
        value: {
          start: "",
          end: "",
        },
      },
      {
        type: "range",
        name: "due_date",
        value: {
          start: "",
          end: "",
        },
      },
    ],
    navigate: {
      tabs: [
        {
          name: "Reports",
          path: "/app/reports",
        },
        {
          name: "Purchase VAT",
          path: ""
        }
      ],
      total: [
        { value: 0, label: "Total" },
        { value: 0, label: "Active" },
        { value: 0, label: "Inactive" },
      ],
    },
  };

  const [header, setHeader] = useState(headers);

  const formdata = (data) => {
    fetchData(data);
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const data = {
        search: tabledata?.search,
        sort: tabledata?.sort,
        supplier: tabledata?.supplier,
        branch: tabledata?.branch,
        status: tabledata?.status,
        date: tabledata?.date,
        due_date: tabledata?.due_date,
      };

      const products = await get_purchase_tax_reports(data);

      if (products?.status) {
        setBody(products?.data?.purchaseReports);
        setRole(products?.data?.role)
        setLoader(false);
      } else {
        toast?.error(products?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB");
  };

  const downloadCSV = () => {
    console.log("Download CSV clicked");
    console.log("Body data:", body);

    if (!body || body.length === 0) {
      console.log("No data available for download");
      toast.error("No data available to download");
      return;
    }

    try {
      const header = ["Purchase", "Supplier", "Branch", "Date", "Subtotal", "Taxable Amount", "Tax", "Total"];

      const rows = body.map((item) => {
        const row = [
          item?.number ? `#INV-${item.number}` : "-",
          item?.customer?.name || "-",
          item?.branch?.name || "-",
          formatDate(item?.delivery_date || item?.date),
          parseFloat(item?.subtotal || 0).toFixed(3),
          parseFloat(item?.taxable_amount || 0).toFixed(3),
          parseFloat(item?.vat_amount || item?.taxamount || 0).toFixed(3),
          parseFloat(item?.total_amount || item?.total || 0).toFixed(3),
        ];
        return row;
      });

      const csvContent = [header, ...rows]
        .map(row => row.map(field => `"${field}"`).join(","))
        .join("\n");

      const encoder = new TextEncoder();
      const encodedContent = encoder.encode('\uFEFF' + csvContent);

      const blob = new Blob([encodedContent], { type: 'text/csv;charset=utf-8' });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);

      link.setAttribute("href", url);
      link.setAttribute("download", `Purchase_Tax_Report_${new Date().toLocaleDateString().replace(/\//g, '_')}.csv`);
      link.style.visibility = 'hidden';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

    } catch (error) {
      console.error("Error generating CSV:", error);
      toast.error("Failed to generate CSV file");
    }
  };

  const downloadPDF = () => {
    if (!body || body.length === 0) return;

    const doc = new jsPDF();
    registerCairoFont(doc);
    const pageWidth = doc.internal.pageSize.getWidth();

    doc.setFont("Cairo-Bold", "bold");

    doc.setFontSize(18);
    doc.text("Purchase Tax Report", pageWidth / 2, 18, { align: "center" });

    const now = new Date();
    const formattedDate = now.toLocaleDateString("en-GB");
    const formattedTime = now.toLocaleTimeString();
    doc.setFontSize(10);
    doc.text(`Downloaded on: ${formattedDate} ${formattedTime}`, pageWidth / 2, 26, { align: "center" });

    const tableRows = body.map((item, index) => [
      item?.number ? `#PO-${item.number}` : "-",
      item?.supplier?.name || "-",
      item?.branch?.name || "-",
      formatDate(item?.delivery_date || item?.date),
      parseFloat(item?.subtotal || 0).toFixed(3),
      parseFloat(item?.taxable_amount || 0).toFixed(3),
      parseFloat(item?.vat_amount || item?.taxamount || 0).toFixed(3),
      parseFloat(item?.total_amount || item?.total || 0).toFixed(3),
    ]);

    autoTable(doc, {
      startY: 32,
      head: [["Purchase", "Suplier", "Branch", "Date", "Subtotal", "Taxable Amount", "Tax", "Total"]],
      body: tableRows,
      styles: {
        font: "Cairo",
        textColor: [0, 0, 0],
        lineColor: [7, 181, 83],
        lineWidth: 0.2
      },
      headStyles: {
        font: "Cairo",
        fontStyle: "bold",
        fillColor: false,
        lineColor: [7, 181, 83],
        lineWidth: 0.6
      },
    });

    doc.save(`Purchase_Tax_Report_${formattedDate}.pdf`);
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (!role) return;

    let updatedHeader = { ...headers };

    if (role !== "SUPERADMIN") {
      updatedHeader.components = updatedHeader.components.filter(
        (item) => item.name !== "branch"
      );
    }

    setHeader(updatedHeader);
  }, [role]);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>

        <div className="text-right  flex gap-3 justify-end mt-4">
          <Button
            className="mr-2  !bg-[#07b553] !border-[#07b553] hover:!bg-[#38cb82] hover:!border-[#38cb82]"
            type="primary"
            onClick={downloadCSV}
          >
            Download CSV
          </Button>

          <ReactToPrint
            trigger={() => (

              <Button
                className="mr-2  !bg-[#07b553] !border-[#07b553] hover:!bg-[#38cb82] hover:!border-[#38cb82]"
                type="primary"
              >
                Download PDF
              </Button>
            )}
            content={() => componentRef}
            pageStyle={`
                                   @page {
                                     size: landscape;
                                     margin: 10mm;
                                   }
                     
                                   @media print {
                                     tfoot {
                                       position: static !important;
                                       bottom: auto !important;
                                     }
                                     thead { 
                                       display: table-header-group !important;
                                     }
                                     tfoot {
                                       display: table-row-group !important;
                                     }
                                   }
                     
                                     table {
                                     border-collapse: collapse;
                                     width: 100%;
                                   }
                                   th, td {
                                     border: 1px solid #ddd;
                                     padding: 6px;
                                   }
                                   th {
                                     background-color: #f4f4f4;
                                   }
                                     @media print {

  table, thead, tbody, tfoot, tr, th, td {
    border: 1px solid #000 !important;
    border-collapse: collapse !important;
  }

  th {
    background-color: #f4f4f4 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  table {
    width: 100% !important;
    border-collapse: collapse !important;
  }

  thead, tfoot {
    position: static !important;
  }
}
                                 `}
          />
        </div>

        <ScrollWrapper>

          <div
            className="max-h-[70vh] overflow-y-auto scrollbar-hide remove-scroll-limit"
            ref={(el) => (componentRef = el)}
          >
            <table className="w-full bg-white">
              <thead className="text-gray-500 sticky top-0 bg-white z-10">
                <tr>
                  <td className="border p-4">Purchase</td>
                  <td className="border p-4">Supplier</td>
                  <td className="border p-4">Branch</td>
                  <td className="border p-4">Date</td>
                  <td className="border p-4">Subtotal</td>
                  <td className="border p-4">Taxable Amount</td>
                  <td className="border p-4">Tax&nbsp;[VAT]</td>
                  <td className="border p-4">Total</td>
                </tr>
              </thead>
              <tbody>
                {body?.map((value, index) => {
                  return (
                    <tr>
                      <td className="border p-4">#PO-{value?.number}</td>
                      <td className="border p-4">
                        <div>{value?.supplier?.name}</div>
                        <div className="text-gray-500 text-xs">
                          {value?.supplier?.tax
                            ? "VATIN : " + value?.supplier?.tax
                            : ""}
                        </div>
                      </td>
                      <td className="border p-4">{value?.branch?.name}</td>
                      <td className="border p-4">
                        {value?.date
                          ? moment?.(value?.date)?.format?.("DD-MM-YYYY")
                          : ""}
                      </td>
                      <td className="border p-4">
                        {value?.subtotal?.toFixed?.(3)}
                      </td>
                      <td className="border p-4">{value?.taxable_amount}</td>
                      <td className="border p-4">
                        {value?.taxamount?.toFixed?.(3)}
                      </td>
                      <td className="border p-4">{value?.total?.toFixed?.(3)}</td>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot className="sticky bottom-0 bg-white z-10">
                <tr className="text-sm font-medium">
                  <td className="border p-4"></td>
                  <td className="border p-4"></td>
                  <td className="border p-4"></td>
                  <td className="border p-4"></td>
                  <td className="border p-4 text-medium">
                    {body
                      ?.reduce(
                        (acc, currentValue) =>
                          parseFloat(acc) + parseFloat(currentValue?.subtotal),
                        0
                      )
                      ?.toFixed(3)}
                  </td>
                  <td className="border p-4 text-medium">
                    {body
                      ?.reduce(
                        (acc, currentValue) =>
                          parseFloat(acc) + parseFloat(currentValue?.taxable_amount),
                        0
                      )
                      ?.toFixed(3)}
                  </td>
                  <td className="border p-4 text-medium">
                    {body
                      ?.reduce(
                        (acc, currentValue) =>
                          parseFloat(acc) + parseFloat(currentValue?.taxamount),
                        0
                      )
                      ?.toFixed(3)}
                  </td>
                  <td className="border p-4 text-medium">
                    {body
                      ?.reduce(
                        (acc, currentValue) =>
                          parseFloat(acc) + parseFloat(currentValue?.total),
                        0
                      )
                      ?.toFixed(3)}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </ScrollWrapper>
      </Loadercomponent>
    </Header>
  );
};

export default PurchasesVatReport;
